import React from 'react'
import CanonicalUrl from './canonical-url'
import MetaDescription from './meta-description'
import MetaViewport from './meta-viewport'
import TitleTag from './title-tag'
import { META_TAGS } from '../../constants'

const View = (props) => {
	const {
		canonicalUrlPathname,
		description,
		title,
		RenderCanonicalUrl,
		RenderMetaDescription,
		RenderMetaViewport,
		RenderTitleTag,
	} = props

	return (
		<React.Fragment>
			<RenderCanonicalUrl
				pathname={canonicalUrlPathname}
				rootUrl={META_TAGS.CANONICAL_URL_ROOT}
			/>
			<RenderMetaDescription
				description={description}
			/>
			<RenderMetaViewport
				viewport={META_TAGS.VIEWPORT_SETTING}
			/>
			<RenderTitleTag
				separator={META_TAGS.PAGE_TITLE_SEPARATOR}
				siteName={META_TAGS.SITE_NAME}
				title={title}
			/>
		</React.Fragment>
	)
}

View.defaultProps = {
	RenderCanonicalUrl: CanonicalUrl,
	RenderMetaDescription: MetaDescription,
	RenderMetaViewport: MetaViewport,
	RenderTitleTag: TitleTag,
}

export default View



// WEBPACK FOOTER //
// ./src/common/components/meta/view.js